"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = manualVideoTimeUpdate;

var _getCurrentClipFromTime = require("../clips/getCurrentClipFromTime");

var _normaliseTime = _interopRequireDefault(require("../normaliseTime"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function stateSelector(_ref) {
  var newElapsedDuration = _ref.newElapsedDuration,
      normalisedTime = _ref.normalisedTime,
      newCurrentClip = _ref.newCurrentClip,
      currentClip = _ref.currentClip;
  return function (_ref2) {
    var buffering = _ref2.buffering;
    return {
      elapsedDuration: newElapsedDuration,
      currentTime: normalisedTime,
      currentClip: newCurrentClip,
      buffering: buffering || newCurrentClip !== currentClip
    };
  };
}

function onUpdateState(_ref3) {
  var videoEl = _ref3.videoEl,
      newCurrentClip = _ref3.newCurrentClip,
      currentVideoTime = _ref3.currentVideoTime;
  return function () {
    if (!newCurrentClip.isEmpty && !newCurrentClip.isImage) {
      // eslint-disable-next-line no-param-reassign
      videoEl.currentTime = Math.round(currentVideoTime * 2) / 2;
    }
  };
}

function manualVideoTimeUpdate(_ref4) {
  var onPause = _ref4.onPause,
      playing = _ref4.playing,
      skipPause = _ref4.skipPause,
      time = _ref4.time,
      totalDuration = _ref4.totalDuration,
      playableClips = _ref4.playableClips,
      currentClip = _ref4.currentClip,
      videoEl = _ref4.videoEl;

  if (!skipPause && playing) {
    onPause();
  }

  var normalisedTime = (0, _normaliseTime.default)(time, totalDuration);
  var newCurrentClipIndex = (0, _getCurrentClipFromTime.getCurrentClipIndexFromTime)(normalisedTime, playableClips);
  var newCurrentClip = playableClips[newCurrentClipIndex];
  var newElapsedDuration = playableClips.slice(0, newCurrentClipIndex).reduce(function (elapsedDuration, clip) {
    return elapsedDuration + clip.duration;
  }, 0);
  var currentVideoTime = time - newElapsedDuration;
  return [stateSelector({
    newElapsedDuration: newElapsedDuration,
    normalisedTime: normalisedTime,
    newCurrentClip: newCurrentClip,
    currentClip: currentClip
  }), onUpdateState({
    videoEl: videoEl,
    newCurrentClip: newCurrentClip,
    currentVideoTime: currentVideoTime
  })];
}